/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyDto } from './loyaltyDto';


export interface TransactionDto { 
    id?: number;
    uuid?: string;
    created?: string;
    status?: TransactionDto.StatusEnum;
    type?: TransactionDto.TypeEnum;
    errorMessage?: string;
    points?: number;
    finishedAt?: string;
    jir?: string;
    invoiceNo?: string;
    invoiceDate?: string;
    invoiceTime?: string;
    image?: string;
    email?: string;
    userId?: number;
    loyaltyPoints?: number;
    couponName?: string;
    loyalty?: LoyaltyDto;
    loyaltyEnded?: boolean;
}
export namespace TransactionDto {
    export type StatusEnum = 'INITIALIZED' | 'SUCCESS' | 'VALIDATION_PENDING' | 'ERROR' | 'DECLINED' | 'REPORTED';
    export const StatusEnum = {
        Initialized: 'INITIALIZED' as StatusEnum,
        Success: 'SUCCESS' as StatusEnum,
        ValidationPending: 'VALIDATION_PENDING' as StatusEnum,
        Error: 'ERROR' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum,
        Reported: 'REPORTED' as StatusEnum
    };
    export type TypeEnum = 'INVOICE_SCAN' | 'COUPON_BOUGHT' | 'MANUAL_TRANSACTION';
    export const TypeEnum = {
        InvoiceScan: 'INVOICE_SCAN' as TypeEnum,
        CouponBought: 'COUPON_BOUGHT' as TypeEnum,
        ManualTransaction: 'MANUAL_TRANSACTION' as TypeEnum
    };
}


